import React from 'react';
import { useAppDispatch } from '../../@types/redux';
import FreshServiceActions from '../../store/freshService/actions';
import { Screen } from '@zz2/zz2-ui';

const NoRightsScreen = () : JSX.Element => {
    const dispatch = useAppDispatch();

    /*================================================================================================================
     *                                                  Effects
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Async Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Handler Methods
     * ==============================================================================================================*/

    const openSupportTicketDialog = () : void => {
        dispatch(FreshServiceActions.setIsSupportTicketDialogOpen(true));
    };

    /*================================================================================================================
     *                                                  Memos
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Render Methods
     * ==============================================================================================================*/

    return (
        <Screen useAnimatedLoader>
            <div className={'fdc hfill jcc aic'}>
                <img src={`${ASSET_BASE}/assets/images/no_rights.svg`}></img>
                <p className={'cg3 fs37'}>Sorry!</p>
                <p className={'cg3 fs25'}>You do not have access to this page.</p>
                <a onClick={openSupportTicketDialog} className='cursorPointer ul cg3'>Click here to open a ticket.</a>
            </div>
        </Screen>
    );
};

export default NoRightsScreen;
